import Link from "next/link";
import styles from "./blockSeven.module.scss";
import Image from "next/image";
import PromptInfo from "../promptInfo/promptInfo";

export default function BlockSeven({ data, load, isAuth, thisIsFile, handlerClick, isSoon, dictionary, serviceData, queryParams }) {
	const imgOneData = data.Min_image.data;
	const imgTwoData = data.Image.data;
	const stepsData = data.Steps;

	return (
		<section className={styles.section}>
			<div className={styles.imgOne}>
				{imgOneData && (
					<Image
						src={imgOneData.attributes.url}
						alt={imgOneData.attributes.alternativeText}
						width={imgOneData.attributes.width}
						height={imgOneData.attributes.height}
						loading="lazy"
						unoptimized={true}
					/>
				)}
				{imgOneData.attributes.caption?.includes("prompt: ") && (<PromptInfo prompt={imgOneData.attributes.caption.replace("prompt: ", "")} />)}
			</div>
			<div className={styles.imgTwo}>
				{imgTwoData && (
					<Image
						src={imgTwoData.attributes.url}
						alt={imgTwoData.attributes.alternativeText}
						width={imgTwoData.attributes.width}
						height={imgTwoData.attributes.height}
						loading="lazy"
						unoptimized={true}
					/>
				)}
				{imgTwoData.attributes.caption?.includes("prompt: ") && (<PromptInfo prompt={imgTwoData.attributes.caption.replace("prompt: ", "")} />)}
			</div>

			<div className={styles.text}>
				<h2 className={styles.title}>{data.Title}</h2>

				<ul className={styles.list}>
					{stepsData.map((item, index) => (
						<li key={item.id} className={styles.listItem}>
							<span>
								{dictionary["step"] || "Step"} {index + 1}
							</span>
							<h3>{item.Title}</h3>
							<p>{item.Description}</p>
						</li>
					))}
				</ul>

				{load && data.Button && isSoon && (
					<button className={styles.btn} onClick={handlerClick} disabled={isAuth}>
						{dictionary["Coming soon"] || "Coming soon"}
					</button>
				)}

				{load && data.Button && !isSoon && (
					<>
						{thisIsFile ? (
							<Link className={styles.btn} href={`/${serviceData.url_name}${queryParams !== "" ? `?${queryParams}` : ""}`}>
								{dictionary["Try"]}
							</Link>
						) : (
							<button className={styles.btn} onClick={handlerClick}>
								{dictionary["Create"] || "Create"}
							</button>
						)}
					</>
				)}
			</div>
		</section>
	);
}
